import { PageResponse } from '@/builders/pageResolver';
import { tvshowEntriesPageBuilder } from '@/builders/pages/sources/tvshowEntriesPageBuilder';
import { tvshowPageBuilder } from '@/builders/pages/sources/tvshowPageBuilder';
import { tvshowSeasonEntriesPageBuilder } from '@/builders/pages/sources/tvshowSeasonEntriesPageBuilder';
import { tvshowSeasonPageBuilder } from '@/builders/pages/sources/tvshowSeasonPageBuilder';
import Layout from '@/components/ui/Layout/Layout';
import Page from '@/components/ui/Page/Page';
import { addCacheHeaders } from '@/utils/cache';
import { entryTypes } from '@/utils/references/entryTypes';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';

type Params = {
  parameters: Array<string>;
};

function TvshowPage(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout useTransparentHeader={props.useTransparentHeader}>
      <Page page={props} />
    </Layout>
  );
}

export default TvshowPage;

export const getServerSideProps = async ({ params, res }: GetServerSidePropsContext<Params>) => {
  if (params === undefined) {
    throw new Error();
  }

  const { parameters } = params;
  const slug = parameters[0];
  const secondSlug = parameters[1] ? parameters[1] : null;
  const thirdSlug = parameters[2] ? parameters[2] : null;
  let typeSlug;
  let seasonSlug;

  if (Array.from(entryTypes.keys()).indexOf(secondSlug) !== -1) {
    // typeSlug is an entry type slug, we are fetching entry type of a tvshow
    typeSlug = secondSlug;
  } else {
    seasonSlug = secondSlug;
  }

  let page: PageResponse;

  try {
    if (seasonSlug && thirdSlug) {
      page = await tvshowSeasonEntriesPageBuilder(slug, seasonSlug, thirdSlug);
    } else if (seasonSlug) {
      page = await tvshowSeasonPageBuilder(slug, seasonSlug);
    } else if (typeSlug) {
      page = await tvshowEntriesPageBuilder(slug, typeSlug);
    } else {
      page = await tvshowPageBuilder(slug);
    }
  } catch (error) {
    console.log(error);
    throw error;
  }

  if (page.notFound) {
    return {
      notFound: true,
      props: {
        ...page,
      },
    };
  }

  addCacheHeaders(res, page);

  return {
    props: {
      key: `${slug}-${typeSlug}`,
      ...page,
    },
  };
};
